'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AGE_SUITABILITY = _constantsAnalytics2.default.CATEGORIES.AGE_SUITABILITY;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS,
    ADD_AGE_SUITABILITY = _analyticsConstants$E.ADD_AGE_SUITABILITY,
    EDIT_AGE_SUITABILITY = _analyticsConstants$E.EDIT_AGE_SUITABILITY,
    REMOVE_AGE_SUITABILITY = _analyticsConstants$E.REMOVE_AGE_SUITABILITY;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS,
    ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;


function composeAgeSuitabilityEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: AGE_SUITABILITY,
    gtmAction: action
  });
}

function composeAddAgeSuitabilityEvent() {
  return (0, _compose.composeAnalytics)([composeAgeSuitabilityEvent(ADD_AGE_SUITABILITY, ADD_CONTENT)]);
}

function composeEditAgeSuitabilityEvent() {
  return (0, _compose.composeAnalytics)([composeAgeSuitabilityEvent(EDIT_AGE_SUITABILITY, EDIT_ITEM)]);
}

function composeRemoveAgeSuitabilityEvent() {
  return (0, _compose.composeAnalytics)([composeAgeSuitabilityEvent(REMOVE_AGE_SUITABILITY, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddAgeSuitabilityEvent: composeAddAgeSuitabilityEvent,
  composeEditAgeSuitabilityEvent: composeEditAgeSuitabilityEvent,
  composeRemoveAgeSuitabilityEvent: composeRemoveAgeSuitabilityEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/ageSuitabilityEventComposer.js
// module id = 572
// module chunks = 0 2 4 5 6 8 9 10 11